/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Action
 */
export interface Action {
  /**
   *
   * @type {string}
   * @memberof Action
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof Action
   */
  date: string;
  /**
   *
   * @type {string}
   * @memberof Action
   */
  actionType: string;
  /**
   *
   * @type {string}
   * @memberof Action
   */
  planName: string;
  /**
   *
   * @type {string}
   * @memberof Action
   */
  planId: string;
  /**
   *
   * @type {string}
   * @memberof Action
   */
  regionName: string;
  /**
   *
   * @type {string}
   * @memberof Action
   */
  regionId: string;
  /**
   *
   * @type {string}
   * @memberof Action
   */
  siteName: string;
  /**
   *
   * @type {string}
   * @memberof Action
   */
  siteId: string;
  /**
   *
   * @type {string}
   * @memberof Action
   */
  cageName: string;
  /**
   *
   * @type {string}
   * @memberof Action
   */
  cageId: string;
  /**
   *
   * @type {number}
   * @memberof Action
   */
  biomass: number | null;
  /**
   *
   * @type {number}
   * @memberof Action
   */
  count: number | null;
  /**
   *
   * @type {number}
   * @memberof Action
   */
  weight: number | null;
  /**
   *
   * @type {number}
   * @memberof Action
   */
  closingCount: number | null;
  /**
   *
   * @type {number}
   * @memberof Action
   */
  closingWeight: number | null;
  /**
   *
   * @type {boolean}
   * @memberof Action
   */
  isLocked: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof Action
   */
  isEmergency: boolean | null;
  /**
   *
   * @type {string}
   * @memberof Action
   */
  fishTypeId: string;
  /**
   *
   * @type {string}
   * @memberof Action
   */
  species: ActionSpeciesEnum | null;
  /**
   *
   * @type {Array<string>}
   * @memberof Action
   */
  certificates?: Array<ActionCertificatesEnum>;
  /**
   *
   * @type {boolean}
   * @memberof Action
   */
  fullHarvest?: boolean | null;
  /**
   *
   * @type {string}
   * @memberof Action
   */
  harvestPlantId?: string;
  /**
   *
   * @type {string}
   * @memberof Action
   */
  harvestPlantName?: string;
  /**
   *
   * @type {string}
   * @memberof Action
   */
  packagingCode?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof Action
   */
  explanations?: Array<ActionExplanationsEnum>;
  /**
   *
   * @type {string}
   * @memberof Action
   */
  fromFishGroupId?: string | null;
  /**
   *
   * @type {string}
   * @memberof Action
   */
  toFishGroupId?: string | null;
}

export const ActionSpeciesEnum = {
  Salmon: 'salmon',
  Trout: 'trout',
} as const;

export type ActionSpeciesEnum = (typeof ActionSpeciesEnum)[keyof typeof ActionSpeciesEnum];
export const ActionCertificatesEnum = {
  Asc: 'ASC',
  Debio: 'Debio',
  Fos: 'FOS',
  GlobalGap: 'GlobalGAP',
  Naturland: 'Naturland',
  Organic: 'Organic',
  PracticeGaabap: 'Practice_GAABAP',
  SoilAssociation: 'SoilAssociation',
  Gladlaks: 'Gladlaks',
  Stp: 'STP',
} as const;

export type ActionCertificatesEnum = (typeof ActionCertificatesEnum)[keyof typeof ActionCertificatesEnum];
export const ActionExplanationsEnum = {
  CageMab: 'cage_mab',
  SiteMab: 'site_mab',
  Fallowing: 'fallowing',
  HarvestPlantCapacity: 'harvest_plant_capacity',
  ConcessionMab: 'concession_mab',
  SiteConcessionLimit: 'site_concession_limit',
  FishValue: 'fish_value',
  HarvestDemand: 'harvest_demand',
  Manual: 'manual',
  Undefined: 'undefined',
  Synchronized: 'synchronized',
} as const;

export type ActionExplanationsEnum = (typeof ActionExplanationsEnum)[keyof typeof ActionExplanationsEnum];
